import React, { useState } from "react";
import styles from "./ChangePasswordModal.module.css";
import { useSelector } from "react-redux";
import { RootState } from "../../Services/Store";
import { toast } from "react-toastify";
import WebService from "../../Services/WebService";
import { FiEye, FiEyeOff } from "react-icons/fi";

interface Props {
  onClose: () => void;
}

const ChangePasswordModal: React.FC<Props> = ({ onClose }) => {
  const [oldPwd, setOldPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [loading, setLoading] = useState(false);

  // Get mobile from Redux
  const mobile_number = useSelector(
    (state: RootState) => state.auth.user?.mobile_number || ""
  );

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Validation
    if (!oldPwd || !newPwd || !confirmPwd) {
      toast.error("All fields are required.");
      return;
    }
    if (newPwd !== confirmPwd) {
      toast.error("New password and confirm password do not match.");
      return;
    }
    if (newPwd.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }
    setLoading(true);
    try {
      await WebService.putAPI({
        action: "/v1/door-management/users/change-password",
        body: {
          old_password: oldPwd,
          new_password: newPwd,
          mobile_number,
        },
      });
      toast.success("Password changed successfully!");
      onClose();
    } catch  {
      // toast.error(
      //   err?.response?.data?.message ||
      //     err?.message ||
      //     "Failed to change password."
      // );
    }
    setLoading(false);
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalBox}>
        <div className={styles.header}>
          <span>Change Password</span>
          <button className={styles.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label>Old Password</label>
            <div className={styles.inputWithIcon}>
              <input
                type={showOld ? "text" : "password"}
                value={oldPwd}
                onChange={(e) => setOldPwd(e.target.value)}
                autoFocus
                required
                placeholder="Enter old password"
              />
              <span
                className={styles.eyeIcon}
                onClick={() => setShowOld((v) => !v)}
                tabIndex={0}
              >
                {showOld ? <FiEyeOff /> : <FiEye />}
              </span>
            </div>
          </div>
          <div className={styles.formGroup}>
            <label>New Password</label>
            <div className={styles.inputWithIcon}>
              <input
                type={showNew ? "text" : "password"}
                value={newPwd}
                onChange={(e) => setNewPwd(e.target.value)}
                required
                placeholder="Enter new password"
              />
              <span
                className={styles.eyeIcon}
                onClick={() => setShowNew((v) => !v)}
                tabIndex={0}
              >
                {showNew ? <FiEyeOff /> : <FiEye />}
              </span>
            </div>
          </div>
          <div className={styles.formGroup}>
            <label>Confirm New Password</label>
            <input
              type="password"
              value={confirmPwd}
              onChange={(e) => setConfirmPwd(e.target.value)}
              required
              placeholder="Confirm new password"
            />
          </div>
          <div className={styles.actions}>
            <button type="submit" className={styles.applyBtn} disabled={loading}>
              {loading ? "Changing..." : "Change Password"}
            </button>
            <button type="button" className={styles.cancelBtn} onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
